import { apiClient } from './client';

// Alineado con aws-serverless/src/models/terrain.model.ts (F1).
// "FarmModule" en el backend para no chocar con los AgroModule del bot;
// aquí se llama simplemente Module.

export const MODULE_STATUSES = ['PREPARACION', 'NORMAL', 'ATENCION', 'CRITICO', 'COSECHANDO'] as const;
export type ModuleStatus = (typeof MODULE_STATUSES)[number];

export interface FarmModule {
  moduleId:     string;
  tenantId:     string;
  ranchoId:     string;
  loteId:       string;
  moduleCode:   string;
  name?:        string;
  valveIds:     string[];
  areaHa?:      number;
  cropName?:    string;
  cropId?:      string;
  cropCycleLabel?: string;
  projectId?:   string;
  parentModuleId?: string;
  plantingDate?: string;
  status:       ModuleStatus;
  statusReason?: string;
  createdAt:    string;
  updatedAt?:   string;
}

export const fetchModules = async (params?: { loteId?: string; projectId?: string; ranchoId?: string | null }): Promise<FarmModule[]> =>
  (await apiClient.get('/api/modules', {
    params: params ? { ...params, ranchoId: params.ranchoId || undefined } : undefined,
  })).data.items;

export const fetchModule = async (moduleId: string): Promise<FarmModule> =>
  (await apiClient.get(`/api/modules/${moduleId}`)).data;

export const PROJECT_STATUSES = ['PLANNED', 'ACTIVE', 'CLOSED'] as const;
export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export interface Project {
  projectId: string;
  tenantId:  string;
  ranchoId:  string;
  name:      string;
  season?:   string;
  startDate: string;
  endDate?:  string;
  currency:  string;
  status:    ProjectStatus;
  createdAt: string;
}

export const fetchProjects = async (ranchoId?: string | null): Promise<Project[]> =>
  (await apiClient.get('/api/projects', { params: ranchoId ? { ranchoId } : undefined })).data.items;
